import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useI18n } from '../../context/I18nContext';
import { useMatrixClient } from '../../context/MatrixContext';

const VzdEndpointList = ({ endpoints, onSelectUser, displayName, selectedUserIds }) => {
  const { t } = useI18n();
  const client = useMatrixClient();
  const currentUserId = client?.getUserId();

  const handleInvite = useCallback((endpoint) => {
    onSelectUser({
      id: endpoint.address,
      name: displayName || endpoint.name || endpoint.address,
    });
  }, [onSelectUser, displayName]);

  if (!endpoints || endpoints.length === 0) {
    return null;
  }

  return (
    <div className="vzd-endpoint-list">
      {endpoints.map((endpoint) => {
        const isInvited = selectedUserIds?.has(endpoint.address);
        const isSelf = endpoint.address === currentUserId;
        return (
          <div key={endpoint.id || endpoint.address} className="vzd-endpoint-item">
            <div className="vzd-endpoint-info">
              {endpoint.name && (
                <div className="vzd-endpoint-name">
                  <span className="vzd-endpoint-label">{t('VzdSearch.endpointName')}:</span> {endpoint.name}
                </div>
              )}
              <div className="vzd-endpoint-address">
                <span className="vzd-endpoint-label">{t('VzdSearch.endpointAddress')}:</span> {endpoint.address}
              </div>
            </div>
            <button
              className={`vzd-invite-button${!isSelf && isInvited ? ' vzd-invite-button--invited' : ''}`}
              disabled={isSelf}
              onClick={() => handleInvite(endpoint)}
            >
              {isSelf ? t('VzdSearch.youButton') : isInvited ? t('VzdSearch.removeButton') : t('VzdSearch.inviteButton')}
            </button>
          </div>
        );
      })}
    </div>
  );
};

VzdEndpointList.propTypes = {
  endpoints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    address: PropTypes.string.isRequired,
    status: PropTypes.string,
  })).isRequired,
  onSelectUser: PropTypes.func.isRequired,
  displayName: PropTypes.string,
  selectedUserIds: PropTypes.instanceOf(Set),
};

export default VzdEndpointList;
